export function safeZendeskLogoutUser(attempts = 10, delay = 300) {
  const tryLogout = () => {
    try {
      if (typeof window.zE === 'function') {
        window.zE?.('messenger', 'logoutUser');
        window.zE?.('messenger', 'reset');
      } else if (attempts > 0) {
        setTimeout(() => safeZendeskLogoutUser(attempts - 1, delay), delay);
      } else {
        console.warn('Zendesk logoutUser not available after waiting.');
      }
    } catch (e) {
      console.error('Zendesk logoutUser error:', e);
    }
  };

  tryLogout();
}
